import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { changeDate } from './actions';

const DateAcceptChange = ({ show, onHide, data }) => {
  const [formData, setFormData] = useState({
    date: '',
    description: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Сброс формы при открытии/закрытии модального окна
  useEffect(() => {
    if (show) {
      setFormData({
        date: '',
        description: ''
      });
      setErrors({});
    }
  }, [show]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Очищаем ошибку при изменении поля
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.date) {
      newErrors.date = 'Дата обов\'язкова';
    }

    if (!formData.description) {
      newErrors.description = 'Причина зміни обов\'язкова';
    } else if (formData.description.length < 5) {
      newErrors.description = 'Причина повинна містити щонайменше 5 символів';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    if (!data || !data.group) {
      alert('Помилка: відсутні дані про групу');
      return;
    }

    const { _id, groups } = data.group;

    if (!groups || !groups.children) {
      alert('Помилка: відсутні дані про дитину');
      return;
    }

    const info = { 
      id_kg: _id, 
      childId: groups.children.childId, 
      id_gr: groups._id, 
      dateFrom: formData.date 
    };

    setLoading(true);

    try {
      await changeDate(info);
      alert('Дата зарахування успішно змінена');
      onHide();
    } catch (err) {
      alert('Помилка зміни дати зарахування');
      console.error('Error changing date:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      date: '',
      description: ''
    });
    setErrors({});
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Змінити дату зарахування дитини</Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="date">
              Дата зарахування *
            </Form.Label>
            <Form.Control
              type="date"
              id="date"
              value={formData.date}
              onChange={(e) => handleInputChange('date', e.target.value)}
              isInvalid={!!errors.date}
            />
            <Form.Control.Feedback type="invalid">
              {errors.date}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label htmlFor="description">
              Причина зміни дати зарахування *
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              id="description"
              value={formData.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
              placeholder="Опишіть причину зміни дати зарахування..."
              isInvalid={!!errors.description}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
              Мінімум 5 символів
            </Form.Text>
          </Form.Group>

          {Object.keys(errors).length > 0 && (
            <Alert variant="warning">
              Будь ласка, заповніть всі обов'язкові поля правильно
            </Alert>
          )}
        </Modal.Body>
        
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={handleClose}
            disabled={loading}
          >
            Скасувати
          </Button>
          <Button 
            variant="primary" 
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                Збереження...
              </>
            ) : (
              'Зберегти зміни'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DateAcceptChange;